<template>
  <transition name="modal">
    <div class="modalcon">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
            <div class="clearfix"></div>
            <div class="mbox ex-modal" v-bind:class="{ 'modal-height': exclusiveAdded, 'prelative': !membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && exclusiveAdded && step === 1}">
              <div class="modal-header prelative">
                <img src="../../assets/images/membership-modal-logo.png" class="notify-logo ex-notify-logo" alt="The Souled Store Logo"/>
                <span class=" closebtn pointer" @click="togglePopupClose" v-if="!(!membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && exclusiveAdded)">
                  <i class="fa fa-close" aria-hidden="true"></i>
                </span>
              </div>
              <div class="modal-body mb0" v-if="exclusiveAdded" :class="membershipManuallyAdded ? 'modal-body-padding' : ''">
                <div class="text-center px10 congrats-text-wrapper">
                  <div class="notify-title dinline">
                    <!-- We’ve added the Exclusive Membership to your cart and -->
                    {{CHECK_THREE_MONTHS_MEMBERSHIP || isExclusiveRenewal ? EXC_POPUP_DATA && EXC_POPUP_DATA.congrats_text : ''}}
                    {{!membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && !isExclusiveRenewal ? EXC_POPUP_DATA && EXC_POPUP_DATA.congrats_text && EXC_POPUP_DATA.congrats_text.split('.')[0] : ''}}
                  </div>
                  <div v-if="exclusiveUser && CHECK_PRODUCT_MATCHES && !isExclusiveRenewal" class="notify-title dinline">Congratulations! You have upgraded your plan to a 12 Month Membership.</div>
                  <div class="exc-saving-modal-msg text-center modal-title" v-if="!CHECK_THREE_MONTHS_MEMBERSHIP && calculations.exclusive_savings && !CHECK_PRODUCT_MATCHES && EXC_POPUP_DATA && EXC_POPUP_DATA.congrats_text && EXC_POPUP_DATA.congrats_text.split('.')[1]">
                    {{EXC_POPUP_DATA.congrats_text.split('.')[1]}}
                  </div>
                  <div class="exc-saving-modal-msg text-center modal-title" v-else-if="showInitialExcPopupOnPdp && !membershipManuallyAdded && !CHECK_THREE_MONTHS_MEMBERSHIP && !CHECK_PRODUCT_MATCHES">
                    You can <span style='color: #1e9053; font-weight: bold'>save {{ currencySymbol }}{{memberSavings || 0}} </span>on this product itself, with The Souled Store Membership.
                  </div>
                  <div class="exc-saving-modal-msg text-center modal-title" v-else-if="!showInitialExcPopupOnPdp && !membershipManuallyAdded && !CHECK_THREE_MONTHS_MEMBERSHIP && calculations.exclusive_savings && !CHECK_PRODUCT_MATCHES || isExclusiveRenewal">
                    you’re <span style='color: #1e9053; font-weight: bold'>SAVING {{ currencySymbol }}{{calculations.total_savings}}</span> on this order itself.
                  </div>
                  <div class="exc-saving-modal-msg text-center modal-title" v-else-if="calculations && calculations.exclusive_savings && membershipManuallyAdded">
                    you’re <span style='color: #1e9053; font-weight: bold'>SAVING {{ currencySymbol }}{{calculations.total_savings}}</span> on this order itself.
                  </div>
                </div>
                <div v-if="CHECK_ANNUAL_MEMBERSHIP || isExclusiveRenewal" class="just-rs">{{EXC_POPUP_DATA && (EXC_POPUP_DATA.product_id === '147501' || isExclusiveRenewal) && EXC_POPUP_DATA.benefit_text || `For just ${currencySymbol} 199/ year you get.`}}</div>
                <div v-if="CHECK_THREE_MONTHS_MEMBERSHIP" class="just-three-months-rs">{{EXC_POPUP_DATA && EXC_POPUP_DATA.benefit_text || 'For the next 3 months you now get:'}}</div>
                <div class="container icons-container">
                  <div class="row">
                    <div class="col-12 popupImg big-discounts">
                      <img :data-src="imgBaseUrl + 'exclusive/icons-01.png'" width="92" class='big-discount-img' alt="Big Discounts"/>
                      <div class="exclusive-benefits"><p class='big-discount-txt'>Big Discounts </p><p class='all-product-txt'>On All Products. Everyday.</p></div>
                    </div>
                    <div class='row col-12 delivery-special-launch-wrapper'>
                      <div class="col-6 popupImg free-delivery">
                        <img :data-src="imgBaseUrl + 'exclusive/icons-03.png'" width="70" class='free-delivery-img' alt="Free Delivery"/>
                        <p class="exclusive-benefits">Free Delivery</p>
                      </div>
                      <div class="col-6 popupImg">
                        <img :data-src="imgBaseUrl + 'exclusive/icons-02.png'" width="55" class='early-access-img' alt="Early Access"/>
                        <p class="exclusive-benefits">Early Access to Special Launches</p>
                      </div>
                    </div>
                  </div>
                </div>
                <button v-if="exclusiveUser && CHECK_PRODUCT_MATCHES && !isExclusiveRenewal" type="submit" class="btn btn-primary btn-block text-uppercase btn-continue pointer" @click="togglePopup">Confirm Upgrade</button>
                <!--
                <div v-else-if="exclusiveUser && CHECK_PRODUCT_MATCHES && isExclusiveRenewal">
                  <div>
                    <button type="submit" class="btn btn-primary btn-block btn-discounted-price pointer" v-if="EXC_POPUP_DATA" @click="discountedShop()">{{EXC_POPUP_DATA && EXC_POPUP_DATA.continue_button_text || 'Continue Shopping At Discounted Prices'}}</button>
                  </div>
                  <div>
                    <button class="btn btn-primary btn-block btn-no-full-price pointer" v-if="EXC_POPUP_DATA && EXC_POPUP_DATA.decline_button_text" @click="removeExcFromCart(GET_MATCHED_PRODUCT_ID)">{{EXC_POPUP_DATA && EXC_POPUP_DATA.decline_button_text || 'Revert to your existing plan'}}</button>
                  </div>
                </div>
                -->
                <div v-else>
                  <button type="submit" class="btn btn-primary btn-block btn-discounted-price pointer" v-if="!membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && EXC_POPUP_DATA" @click="discountedShop()">{{EXC_POPUP_DATA && EXC_POPUP_DATA.continue_button_text || 'Continue Shopping At Discounted Prices'}}</button>
                </div>
                <div>
                  <button class="btn btn-primary btn-block btn-no-full-price pointer" v-if="!membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && EXC_POPUP_DATA && EXC_POPUP_DATA.decline_button_text" @click="removeExcFromCart(GET_MATCHED_PRODUCT_ID)">{{EXC_POPUP_DATA && EXC_POPUP_DATA.decline_button_text || 'Revert to your existing plan'}}</button>
                </div>
              </div>
              <div class="modal-body mb0" v-else>
                <div class="exc-desktop-header" style="margin-top: 10px;">
                  <p class="fbold bigDiscounts">BIG DISCOUNTS<span class="fbold everyDayDeals"> ON EVERY PRODUCT EVERY DAY</span></p>
                </div>
                <div class="exc-mobile-header" style="">
                  <div class="fbold bigDiscounts">BIG DISCOUNTS</div>
                  <div class="fbold everyDayDeals">ON EVERY PRODUCT EVERY DAY</div>
                </div>
                <p class="text-center dyk-text">(Did you know? The average Member saves {{ currencySymbol }} 2600/year)</p>
                <div>
                  <p class="select-mem-header fsemibold text-center">Select Your Membership</p>
                </div>
                <div class="hello">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-12" v-if="!dynamicExclusiveCards">
                        <mainExclusiveCards :addExclusiveMem="addExclusive" :title_content="title_content" 
                          :popular_head="popular_head" :card_inactive="card_inactive" :card_active="card_active"
                          :add_to_cart_btn="add_to_cart_btn" :togglePopup="togglePopup"></mainExclusiveCards>
                      </div>
                      <div class="col-12" v-if="dynamicExclusiveCards">
                        <mainExcDynamicCardsVue :addExclusiveMem="addExclusive" :title_content="title_content" 
                          :popular_head="popular_head" :card_inactive="card_inactive" :card_active="card_active"
                          :add_to_cart_btn="add_to_cart_btn" :togglePopup="togglePopup"></mainExcDynamicCardsVue>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!membershipManuallyAdded && !CHECK_PRODUCT_MATCHES && !CHECK_THREE_MONTHS_MEMBERSHIP && exclusiveAdded && step === 1" class='exclusive-gif-wrapper pabsolute' id='exclusive-gif-wrapper'>
              <img :src='exclusiveGifToShow' class='exclusive-gif' v-if="showGif" alt="Exclusive Membership"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import mainExclusiveCards from './mainExcCards.vue'
  import mainExcDynamicCardsVue from './mainExcDynamicCards.vue'
  import {mapGetters} from 'vuex'

  var $ = require('jquery')
  window.jQuery = $

  export default {
    data () {
      return {
        email: '',
        error: '',
        hideExclusiveCard: false, // for hiding one month exclusive card for a time period
        step: 1,
        exclusiveGif: 'https://tss-static-images.gumlet.io/exclusive-membership-envelope.gif',
        exclusiveGifToShow: '',
        showGif: false,
        imgBaseUrl: process.env.STATIC_IMG_SERVER2
      }
    },
    props: ['addExclusive', 'togglePopup', 'exclusiveAdded', 'uncheckCheckbox', 'removeExcFromCart', 'memberSavings', 'isExclusiveRenewal'],
    components: {mainExclusiveCards, mainExcDynamicCardsVue},
    computed: {
      ...mapGetters(['authStatus', 'calculations', 'exclusiveProduct', 'membershipManuallyAdded', '_cart', 'site_config', 'exclusiveUser', 'excPopupData', 'showInitialExcPopupOnPdp', 'currencySymbol', 'membershipData', 'bannerPlcaeHolderData']),
      title_content () {
        return 'color: #646768'
      },
      popular_head () {
        return {'text-transform': 'uppercase', 'border-radius': '12px 12px 0px 0px'}
      },
      card_inactive () {
        return {'border': '2px #ffffff solid', 'margin': '0px 5px', 'border-radius': '15px'}
      },
      card_active () {
        return {'-webkit-transform': 'scale(1.05)', 'transform': 'scale(1.05)', 'margin': '0px 5px', 'border-radius': '15px'}
      },
      add_to_cart_btn () {
        return {'color': '#ffffff', 'border-radius': '6px', 'margin-top': '30px', 'background-color': '#1a1f29', 'border-color': '#1a1f29', 'width': '50%', 'text-transform': 'uppercase'}
      },
      CHECK_PRODUCT_MATCHES: function () {
        let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
        if (excProduct) {
          let matchProductId = this.site_config.exclusive_products_upgrade.some(upgradeItem => parseInt(upgradeItem.prod_id) === excProduct.parent_prod_id)
          return matchProductId
        }
        return false
      },
      GET_MATCHED_PRODUCT_ID: function () {
        let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
        if (excProduct) {
          return parseInt(excProduct.prod_id)
        }
        return ''
      },
      CHECK_ANNUAL_MEMBERSHIP: function () {
        let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
        let yearlyProdId = this.site_config.exclusive_products.find((ele) => ele.name.toLowerCase() === ('Yearly').toLowerCase() && ele.duration === 365)
        if (excProduct) {
          return parseInt(excProduct.parent_prod_id) === parseInt(yearlyProdId.prod_id)
        }
        return false
      },
      CHECK_THREE_MONTHS_MEMBERSHIP: function () {
        let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
        let quarterlyProdId = this.site_config.exclusive_products.find((ele) => ele.name.toLowerCase() === ('Quarterly').toLowerCase() && ele.price === 0)
        if (excProduct) {
          return parseInt(excProduct.parent_prod_id) === parseInt(quarterlyProdId.prod_id) && excProduct.price === 0
        }
        return false
      },
      EXC_POPUP_DATA: function () {
        let excPopupDetails = this.excPopupData
        if (excPopupDetails && Object.keys(excPopupDetails).length) {
          excPopupDetails.congrats_text = this.replaceText(excPopupDetails.congrats_text, '@', `SAVING ${this.currencySymbol} ${this.calculations.total_savings}`)
          excPopupDetails.benefit_text = this.replaceText(excPopupDetails.benefit_text, '@', `${parseInt(excPopupDetails.product_id) === 147501 ? 2 : 3}`)
          return excPopupDetails
        }
      },
      dynamicExclusiveCards () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Exclusive'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'DYNAMIC_EXCLUSIVE_CARD')
      }
    },
    mounted () {
      if (this.exclusiveAdded) {
        const img = new Image()
        img.onload = () => {
          this.exclusiveGifToShow = img.src
          this.showGif = true
          setTimeout(() => {
            this.step = 2
          }, 1200)
        }
        img.src = this.exclusiveGif
      }
      document.body.addEventListener('keyup', e => this.escapeKeyPressHandler(e))
      this.shouldhideExclusiveCard()
    },
    destroyed () {
      this.$store.commit('MEMBERSHIP_MANUALLY_ADDED', false)
    },
    methods: {
      replaceText (str, replaceKey, replacetxt) {
        let newStr = str && str.replace(replaceKey, replacetxt)
        return newStr
      },
      notifyMe () {
        this.$validate().then((success) => {
          if (success) {
            this.$store.dispatch('NOTIFY_ME', {email: this.email})
          }
        })
      },
      escapeKeyPressHandler (e) {
        if (e.keyCode === 27) {
          this.togglePopup()
        }
      },
      shouldhideExclusiveCard: function () {
        const currentTime = new Date()
        if (currentTime - new Date('2019-12-20 00:00') > 0 && currentTime - new Date('2019-12-20 23:59') < 0) {
          this.hideExclusiveCard = true
        }
      },
      togglePopupClose: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'exclusive_membership_popup_close', payload: {}})
        this.togglePopup()
        // to remove exc mem on clicking close btn
        // if (this.exclusiveAdded && !this.membershipManuallyAdded && !this.CHECK_PRODUCT_MATCHES && !this.CHECK_THREE_MONTHS_MEMBERSHIP) {
        //   this.removeExcFromCart(this.GET_MATCHED_PRODUCT_ID)
        // }
      },
      discountedShop: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'exclusive_membership_discounted_price', payload: {}})
        const selectedMembership = this.membershipData.ex_banner.filter((item) => item.membership_id === this.excPopupData.product_id)
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'ADD_MEMBERSHIP_TO_CART',
          payload: {
            exclusive_tracker: this.$route.path,
            SUBSCRIPTION_PLAN: selectedMembership.length && selectedMembership[0].duration || 'NA',
            AMOUNT: selectedMembership.length && selectedMembership[0].total_price || 'NA'
          }}
        )
        this.togglePopup()
      }
    },
    created () {
      $('body').addClass('_freeze')
    },
    beforeDestroy () {
      $('body').removeClass('_freeze')
    }
  }
</script>

<style lang="css" scoped>
.px10{
  padding-left: 10px;
  padding-right: 10px;
}
.dinline{
  display: inline;
}
.exclusive-gif-wrapper{
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 15px;
}
.exclusive-gif{
  width: 100%;
  height: 100%;
  border-radius: 15px;
}
.big-discount-img{
  width: 64px;
}
.free-delivery-img{
  width: 60px;
}
.early-access-img{
  width: 50px;
}
.delivery-special-launch-wrapper{
  padding: 0.5rem 0rem;
}
.free-delivery{
  border-right: 1px solid rgba(0,0,0,.125);
}
.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #282d3f;
}
.exc-saving-modal-msg {
  margin-bottom: 18px;
  display: block;
}
.just-rs {
  margin-bottom: 18px;
  text-align: center;
  font-weight: 600;
  color: #282d3f;
}
.congrats-text-wrapper{
  margin-bottom: 18px;
}
.just-three-months-rs {
  margin: 20px 0;
  text-align: center;
  color: #E66A51;
}
.benefit-msg {
  color: #525964;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 0px;
}

.benefit-msg p {
  margin: 0;
}

.showAuth-status {
  text-decoration: underline;
  color: #414141;
  text-align: center;
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 6px;
  cursor: pointer;
  font-weight: bold;
}
.popupImg {
  display:flex; 
  justify-content: center;
  align-items: center;
  gap: .2rem
}

.popupImg p{
  margin-bottom: unset;
}

.big-discounts {
  border-bottom: 1px solid rgba(0,0,0,.125);
  padding-bottom: 10px;
}

.card{
  margin: 5px;
  position: relative;
  width: 45%;
  height: 210px;
  border-radius: 15px;
  box-shadow:
  0 4px 2.2px rgba(0, 0, 0, 0.034),
  0 4px 10px rgba(0, 0, 0, 0.086),
  0 4px 20px rgba(0, 0, 0, 0.12);
  -webkit-transition: .1s;
  transition: .1s;
}
.card:hover{
  cursor: pointer;
}

.active {
  border: 2px #1a1f29 solid;
  -webkit-transform: scale(1.05);
    transform: scale(1.05);
  background-color: #FFF;
}

.title{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 20%;
}

.title-main {
  font-weight: bold;
}

.title h2 {
  position: relative;
  margin: 1px  0 0;
  color: black;
  font-size: 25px;
  z-index: 2;
}

.popular{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 0%;
}

.popular-main {
  color: #ffffff;
  font-weight: bold;
  font-size: 20px;
  padding: 5px;
  margin-top: -1px;
  background-color: #E66A51;
  border-radius: 12px 12px 0px 0px;
  -webkit-transform: scale(1.01);
    transform: scale(1.01);
}

.month {
  font-size: 12px;
  margin-bottom: 5px;
}

.membership-border {
  margin-top:2px;
  margin-bottom: 5px;
  width: 80%;
  background: #D3D3D3;
}
.price{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
}

.card a {
  padding-top: 2.5%;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
  background: #ed2e30;
  color : white;
  width: 90px;
  height: 30px;
  border-radius: 40px;
  display: block;
  text-align: center;
  margin: 10px auto 0 ;
  font-size: 85%;
  cursor: pointer;
}

.card a:hover{
  text-decoration: none;
  color: white;
}

.title h5 {
  margin-bottom: 5px;
  font-size: 20px;
}

.price h4 {
  margin: 0;
  color: #E66A51;
  font-size: 26px;
  font-weight: bold;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 2;
}

  .exc-original-price {
    color: #646768;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 35%;
  }
  .exc-original-price .og-price {
    font-size: 18px;
  }
  .ex-saving {
    color: #3ABDAF;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 80%;
  }
  .ex-saving .saving-price {
    font-size: 18px;
    font-weight: bold;
  }
  

  .modal-header {
    border: none;
  }

  .notify-logo {
    margin: 0 auto;
    height: 120px;
  }

  .ex-notify-logo {
    height: 105px;
  }

  .add-cart-btn {
    background: #E66A51;
    color: #ffffff;
    border-color: #E66A51;
    letter-spacing: 1px;
    margin: 0 auto;
    margin-top: 15px;
    width: 60%;
  }

  .add-cart-btn:hover {
    color: #ffffff;
    background: #e25237;
    border-color: #e25237;
  }

  .btn-discounted-price {
    background: #E66A51;
    -webkit-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
    -moz-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
    box-shadow: 4px 4px 14px 0px rgba(0,0,0,0.4);
    border: 1px solid #E66A51;
    margin: 0 auto;
    width: 320px;
    padding: 7px;
    margin-top: 10px;
  }
  .btn-no-full-price{
    background-color: white;
    color : #E66A51;
    border: 1px solid #E66A51;
    margin: 0 auto;
    width: 320px;
    padding: 7px;
    margin-top: 15px;
  }
  .btn-continue {
    -webkit-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
    -moz-box-shadow: 4px 4px 14px 0px rgba(255,255,255,1);
    box-shadow: 4px 4px 14px 0px rgba(0,0,0,0.4);
    border: none;
    background: #E66A51; padding: 7px;
    letter-spacing: 1px;
    margin: 0 auto;
    margin-top: 20px;
    width: 270px;
  }

  .btn-continue:hover {
    background: #e25237;
  }

  .closebtn {
    border-radius: 24px;
    position: absolute;
   right: 19px;
    top: 9px;
    cursor: pointer;
    font-size: 18px;
  }
  .congratulations {
    color: #73040a;
    font-size: 25px;
  }

  .notify-title {
    text-align: center;
    margin-top: 10px;
    font-size: 18px;
    line-height: 22px;
    color: #555;
    font-weight: 600;
    color: #282d3f;
  }

  .modal-height .notify-title {
    font-size: 16px;
    letter-spacing: 0px;
  }

  .info {
    font-size: 14px;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 560px;
    margin: 0px auto;
    transition: all .3s ease;
    position: relative;
  }
  .icons-container{
    padding: 0 4rem;
    margin-top: -0.5rem;
  }

  .modal-height {
    height: fit-content !important;
    background: url('https://tss-static-images.gumlet.io/exclusive-modal-bg-1.png') !important;
    background-size: cover !important;
  }
  .error {
    text-align: left;
  }

  .mbox {
    background: #fff;
    padding: 10px;
    padding-bottom: 0;
    border-radius: 15px;
    letter-spacing: 0px;
    text-align: left;
  }
  .modal-height {
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
  }

  .modal-header,
  .modal-body {
    padding: 5px 10px;
  }
  .modal-height .modal-body {
    padding-bottom: 15px;
  }
  .modal-height .modal-body-padding {
    padding-bottom: 30px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-enter .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .btn {
    margin-bottom: 15px;
  }

  .notify-message {
    color: #90050d;
    margin-bottom: 10px;
  }

  .form-control, .btn {
    border-radius: 10px;
  }

  .bigDiscounts {
    color: #E66A51;
    font-size: 18px;
    text-align: center;
    margin-bottom: 0;
  }

  .everyDayDeals {
    color: #646768;
    font-size: 18px;
    line-height: 15px;
    text-align: center;
  }

  .dyk-text {
    color: #646768;
    font-size: 13px;
  }

  .select-mem-header {
    color: #a7a8a9;
    font-size: 12px;
    text-align: start;
  }

  .exc-add-btn-wrapper {
    text-align: center;
    text-transform: uppercase;
  }

  .exclusive-benefits {
    text-align: center;
    font-weight: bold;
    color: #E66A51;
  }
  .exclusive-benefits p{
    margin-bottom: unset;
  }
  .exclusive-benefits .big-discount-txt{
    text-transform: uppercase;
    font-size: 2.2rem;
  }
  .exclusive-benefits .all-product-txt{
    text-transform: uppercase;
    margin-top: -0.5rem;
    font-size: 16.3px;
  }

  @media screen and (min-width: 769px) {
    .exc-desktop-header {
      margin: 0px;
    }

    .exc-mobile-header {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .congrats-text-wrapper{
      margin-bottom: 10px;
    }
    .icons-container {
      padding: 0 1rem;
      margin-top: unset;
    }
    .exclusive-benefits {
      font-size: 12px;
    }
    .exclusive-benefits .big-discount-txt{
      font-size: 1.8rem;
    }
    .exclusive-benefits .all-product-txt{
      font-size: 14px;
    }
    .btn-no-full-price {
      padding: 4px 0px;
      margin-top: 15px;
    }
    .btn-discounted-price {
      padding: 4px 0px;
      margin-top: unset;
    }
    .modal-title {
      font-size: 16px;
    }
    .exc-desktop-header {
      display: none;
    }

    .exc-mobile-header {
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 576px) {
    .modal-container {
      width: 92%;
    }
    .exc-saving-modal-msg {
      display: inline;
    }
  }

  @media screen and (max-width: 480px) {
    .modal-title {
      font-size: 12px;
    }
    .notify-title {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 10px;
      margin-top: 5px;
    }
    ul {
      font-size: 14px;
      margin-bottom: 10px;
    }
    .btn {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .congratulations {
      font-size: 22px;
    }
    .mbox {
      padding: 0;
    }
    .notify-logo {
      height: 64px;
    }
    .membership-content h6 {
      font-size: 14px;
    }

    .price h4 {
      font-size: 20px; 
    }
    .card {
      height: 150px;
    }
    .title h5 {
      margin-bottom: 0px;
      font-size: 18px;
    }
    .exc-original-price .og-price {
      font-size: 16px;
    }
    .ex-saving .saving-price {
      font-size: 14px;
    }
    .popular-main {
      font-size: 12px;
    }
    .modal-body {
      padding: 5px;
    }
    .modal-height .notify-title {
      font-size: 12px;
      margin-bottom: 0px;
    }
    .modal-height {
      border-bottom-left-radius: 22px;
      border-bottom-right-radius: 22px;
    }
    .benefit-msg {
      font-size: 12px;
    }
    .congrats-text-wrapper {
      margin-bottom: 7px;
    }
    .just-rs {
      font-size: 11px;
      margin-bottom: 3px;
    }
    .icons-container {
      padding: 0px 16px;
    }
    .big-discount-img {
      width: 52px;
    }
    .exclusive-benefits .big-discount-txt {
      font-size: 1.2rem;
    }
    .exclusive-benefits .all-product-txt{
      font-size: 12px;
      margin-top: -5px;
    }
    .delivery-special-launch-wrapper{
      padding: 0.2rem 0rem;
    }
    .free-delivery-img{
      width: 58px;
    }
    .exclusive-benefits {
      font-size: 10px;
    }
    .early-access-img {
      width: 58px;
    }
    .btn-discounted-price {
      font-size: 12px;
      margin-top: 5px;
      margin-bottom: 10px;
      padding: 0px 0px;
      border-radius: 7px;
      width: 276px;
    }
    .btn-no-full-price {
      font-size: 12px;
      margin-top: 0px;
      margin-bottom: 10px;
      padding: 0px 0px;
      border-radius: 7px;
       width: 276px;
    }
    .big-discounts {
      padding-bottom: 0px;
    }
     .modal-body-padding {
      padding-bottom: 20px;
    }


  }
  @media screen and (max-width: 320px) {
    .container-fluid {
      padding-left: 5px;
      padding-right: 5px;
    }
    .add-cart-btn {
      margin-top: 10px !important;
      color: red;
    }
    .exc-mobile-header {
      margin-bottom: 5px;
    }
    .notify-logo {
      height: 54px;
    }
    .btn-discounted-price {
      width: 222px;
      font-size: 10px;
      border-radius: 5px;
      line-height: 22px;
    } 
     .btn-no-full-price{
      width: 222px;
      font-size: 10px;
      border-radius: 5px;
      line-height: 22px;
      margin-top: 0px !important;
      margin-bottom: 5px;
    }
    .exclusive-benefits .big-discount-txt{
      font-size: 1rem;
    }
    .exclusive-benefits {
      font-size: 10px;
    }
    .exclusive-benefits .all-product-txt {
      font-size: 10px;
    }
    .modal-height .notify-title{
      font-size: 11px;
    }
    .modal-title {
      font-size: 11px;
    }
    .just-rs {
      font-size: 10px;
    }
    .big-discount-img {
      width: 42px;
    }
    .free-delivery-img {
      width: 47px;
    }
    .early-access-img {
      width: 44px;
    }
  }

  @media screen and (max-width: 991px) {
    .card a {
      padding-top: 4%;
    }
  }
</style>



// WEBPACK FOOTER //
// ExclusiveModal.vue?4bf4d76c